import CustomerCareKeys from '../../../../locales/keys';
import { MetadataConstants, MetadataSelectors } from 'invision-core';
import { setCurrentStepIsInvalid, updateCustomerInfoEditCopy, updateCustomerInfoEditCopyPromise } from '../../../../reducers/actions/new.connect.wizard.actions';
import { CreatedCustomerSelector, CustomerInfoSelector, EditCustomerInfoSelector } from '../../../../reducers/selectors/new.connect.wizard.selectors';
import { DriversLicenseStateRegionProvinceValueOptions, StateRegionProvinceValueOptions } from '../../newConnectWizard/new.connect.wizard.selectors';
import { IsQuotingOfferSelector } from '../../../../reducers/selectors/offering.order.selectors';
import { MarkMandatoryCreditCheckFieldsDisabledSelector } from '../../../../reducers/selectors/credit.check.selectors';
import { FormattedNewCustomerSubscriberIdentitiesSelector } from '../../../../reducers/selectors/customer.information.selectors';
function CustomerController($scope, $ngRedux) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      addressCountries: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.AddressCountry, store),
      addressStates: StateRegionProvinceValueOptions(store),
      driversLicenseStateOptions: DriversLicenseStateRegionProvinceValueOptions(store),
      createdCustomer: CreatedCustomerSelector(store),
      customerInfo: CustomerInfoSelector(store),
      editCustomerInfo: EditCustomerInfoSelector(store),
      formattedNewCustomerSubscriberIdentities: FormattedNewCustomerSubscriberIdentitiesSelector(store).asMutable({
        deep: true
      }),
      isQuotingOrder: IsQuotingOfferSelector(store),
      markMandatoryCreditCheckFieldsDisabled: MarkMandatoryCreditCheckFieldsDisabledSelector(store)
    };
  };
  this.$onInit = function () {
    var controllerActions = {
      setCurrentStepIsInvalid: setCurrentStepIsInvalid,
      updateCustomerInfoEditCopy: updateCustomerInfoEditCopy,
      updateCustomerInfoEditCopyPromise: updateCustomerInfoEditCopyPromise
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.customerCareKeys = CustomerCareKeys;
    _this.actions.updateCustomerInfoEditCopy(_this.state.customerInfo);
    _this.actions.setCurrentStepIsInvalid(true);
    // Wait for the form to be rendered so it can tell us if it's valid
    $scope.$evalAsync(function () {
      _this.actions.setCurrentStepIsInvalid(_this.customerForm.$invalid);
      _this.onPropertyChange();
    });
    _this.handleFormChanged = function (customerModel) {
      _this.actions.updateCustomerInfoEditCopyPromise(customerModel).then(function () {
        var apErrors = _this.customerForm.createCustomerForm.addlApi ? _this.customerForm.createCustomerForm.addlApi.$error : null;
        var hasError = apFormHasErrors(apErrors);
        _this.actions.setCurrentStepIsInvalid(hasError || _this.customerForm.$invalid);
      });
    };
    _this.onPropertyChange = function () {
      var apErrors = _this.customerForm.createCustomerForm.addlApi ? _this.customerForm.createCustomerForm.addlApi.$error : null;
      var hasError = apFormHasErrors(apErrors);
      _this.actions.setCurrentStepIsInvalid(hasError || _this.customerForm.$invalid);
    };
  };
  function apFormHasErrors(ngFormError) {
    var hasError = false;
    if (ngFormError) {
      var errorTypes = Object.keys(ngFormError);
      hasError = errorTypes.some(function (errorType) {
        return errorType === 'required' || errorType === 'pattern' || errorType === 'undefined';
      });
    }
    return hasError;
  }
  this.$onDestroy = function () {
    disconnectRedux();
  };
}
export default {
  template: require('./customer.html'),
  controller: CustomerController,
  controllerAs: 'customerController',
  require: {
    wizardForm: '^form'
  },
  bindings: {
    formErrors: '<',
    removeMultiOfferValidations: '<?'
  }
};